<template>
	<div>
		<Navbar/>
	</div>
</template>

<script>
import Navbar from '@/components/ui/Navbar'

export default {
	name: 'Header',
	components: {
		Navbar,
	}
}
</script>

<style scoped>

</style>